"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SetPageVideoGalleryModuleLayouts = void 0;
exports.SetPageVideoGalleryModuleLayouts = [
    "grid",
    "swiper",
    "masonry",
    "carousel",
];
//# sourceMappingURL=VideoGallery.js.map